module.exports = __webpack_public_path__ + "static/media/icon-drop-down.d02276f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/help/section-content/img/icon-drop-down.svg
// module id = 1130
// module chunks = 2